import type { StoreActionApi } from 'react-sweet-state';

import type { SNIPPET_CATEGORY_IDS } from '../../constants/snippetCategories.ts';
import type { SnippetSortOrder } from '../../constants/snippetSortOrder.ts';
import { getInitialTemplateGalleryState, type SnippetsState } from '../snippetsStore.types.ts';

let urlSyncHandler: ((id: string | null) => void) | null = null;

/**
 * Registers a callback to sync store changes to the URL. TemplateGallery calls this
 * when Block tab is active so prev/next/close updates propagate to the URL.
 */
export const setUrlSyncHandler = (handler: ((id: string | null) => void) | null): void => {
	urlSyncHandler = handler;
};

export const templateGalleryActions = {
	setTemplateGallerySelectedSnippetId:
		(id: string | null) =>
		({ getState, setState }: StoreActionApi<SnippetsState>): void => {
			setState({
				templateGallery: { ...getState().templateGallery, selectedSnippetId: id },
			});
			urlSyncHandler?.(id);
		},

	setTemplateGalleryCategoryFilter:
		(selectedCategoryId: SNIPPET_CATEGORY_IDS) =>
		({ getState, setState }: StoreActionApi<SnippetsState>): void => {
			setState({
				templateGallery: { ...getState().templateGallery, selectedCategoryId },
			});
		},

	setTemplateGallerySearchQuery:
		(searchQuery: string) =>
		({ getState, setState }: StoreActionApi<SnippetsState>): void => {
			setState({
				templateGallery: { ...getState().templateGallery, searchQuery },
			});
		},

	setTemplateGallerySortOrder:
		(sortOrder: SnippetSortOrder) =>
		({ getState, setState }: StoreActionApi<SnippetsState>): void => {
			setState({
				templateGallery: { ...getState().templateGallery, sortOrder },
			});
		},

	resetTemplateGalleryFilters:
		() =>
		({ getState, setState }: StoreActionApi<SnippetsState>): void => {
			const { selectedSnippetId } = getState().templateGallery;
			setState({
				templateGallery: {
					...getInitialTemplateGalleryState(),
					selectedSnippetId,
				},
			});
		},
};
